import React from 'react';

import Home from './pages/Home';
import GlobalStyles from './GlobalStyles';

function App() {
  return (
    <div className="App">
      <Home />
      <GlobalStyles />
    </div>
  );
}

export default App;
